import { createAction, props } from '@ngrx/store';
import { QuickEventStatistic } from '../../models/quick-event-statistic';

export enum QuickEventStatisticActionTypes {
  LoadQuickEventStatistic = '[Quick Event Statistic] Get Quick Event Statistic',
  LoadQuickEventStatisticSuccess = '[Quick Event Statistic] Get Quick Event Statistic Success',
  LoadQuickEventStatisticError = '[Quick Event Statistic] Get Quick Event Statistic Error',
  QuickEventStatisticCleanup = '[Quick Event Statistic] Cleanup',
}

export const getQuickEventStatistic = createAction(
  QuickEventStatisticActionTypes.LoadQuickEventStatistic,
  props<{ quickEventId: string }>(),
);

export const getQuickEventStatisticSuccess = createAction(
  QuickEventStatisticActionTypes.LoadQuickEventStatisticSuccess,
  props<{ quickEventStatistic: QuickEventStatistic }>(),
);

export const getQuickEventStatisticError = createAction(
  QuickEventStatisticActionTypes.LoadQuickEventStatisticError,
  props<{ errorMessage: string }>(),
);

export const cleanUpQuickEventStatistic = createAction(
  QuickEventStatisticActionTypes.QuickEventStatisticCleanup,
);
